export default __webpack_public_path__ + "media/images/theme/bg_light-afc9a9cc3b7469eb30fd11d509577cb2.png";